import MesajOkumaBilgisiRequest from "src/models/Mesaj/MesajOkumaBilgisiRequest";
import api from "../core/api";
import VwGnlMesajDTO from "src/models/Mesaj/VwGnlMesajDTO";
import MesajOkumaBilgisiResponse from "src/models/Mesaj/MesajOkumaBilgisiResponse";

const controllerName = "Mesaj";

const MesajApi = api.injectEndpoints({
    endpoints: (builder) => ({
        MesajOkundu: builder.query<boolean, { mesajId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/MesajOkundu",
                    method: "GET",
                    params: request
                }
            },
            providesTags: ["MesajOkundu"]
        }),
        MesajModulOkumaBilgi: builder.query<Array<MesajOkumaBilgisiResponse>, MesajOkumaBilgisiRequest>({
            query: (request) => {
                return {
                    url: controllerName + "/MesajModulOkumaBilgi",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            providesTags: ["MesajModulOkumaBilgi"]
        }),
        MesajModulListesi: builder.query<Array<VwGnlMesajDTO>, { organizasyonId: number, page: number, pageSize: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/MesajModulListesi",
                    method: "GET",
                    params: request
                }
            },
            providesTags: ["MesajModulListesi"]
        }),
        MesajPersonelOkumaBilgi: builder.query<Array<MesajOkumaBilgisiResponse>, MesajOkumaBilgisiRequest>({
            query: (request) => {
                return {
                    url: controllerName + "/MesajPersonelOkumaBilgi",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            providesTags: ["MesajOkumaBilgi"]
        }),
        MesajPersonelListesi: builder.query<Array<VwGnlMesajDTO>, { muracaatId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/MesajPersonelListesi",
                    method: "GET",
                    params: request
                }
            },
            providesTags: ["MesajListesi"]
        }),
        MesajEkle: builder.mutation<VwGnlMesajDTO, VwGnlMesajDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/MesajEkle",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["MesajListesi", "MesajOkumaBilgi", "MesajModulListesi", "MesajModulOkumaBilgi"]
        }),
        MesajGuncelle: builder.mutation<VwGnlMesajDTO, VwGnlMesajDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/MesajGuncelle",
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["MesajListesi", "MesajOkumaBilgi", "MesajModulListesi", "MesajModulOkumaBilgi"]
        }),
        MesajSil: builder.mutation<VwGnlMesajDTO, VwGnlMesajDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/MesajSil",
                    method: "DELETE",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["MesajListesi", "MesajOkumaBilgi", "MesajModulListesi", "MesajModulOkumaBilgi"]
        }),
    })
});

export const {
    useLazyMesajOkunduQuery,
    useMesajModulOkumaBilgiQuery,
    useMesajModulListesiQuery,
    useLazyMesajPersonelOkumaBilgiQuery,
    useMesajPersonelListesiQuery,
    useMesajEkleMutation,
    useMesajGuncelleMutation,
    useMesajSilMutation,
} = MesajApi;